"use client";

import { Navbar } from "home/Navbar";
import ExperienceSelector from "../score-check/components/ExperienceSelector";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { ToastContainer } from "react-toastify";
import { getResumeCache, setExperienceCache } from "../score-check/utils/localStorageHelper";
import { useAppSelector } from "lib/redux/hooks";
import { selectResume } from "lib/redux/resumeSlice";
import { AuthenticationOptions } from "components/AuthenticationOptions";
import {  selectIsAuthenticationOpen, setIsAuthenticationOpen } from "lib/redux/uiSlice";
import { useDispatch } from "react-redux";

const SelectExperiencePage = () => {
  const [experienceLevel, setExperienceLevel] = useState<"FRESHER" | "EXPERIENCED" | null>(null);
  const [isExperienceSelected, setIsExperienceSelected] = useState(false);
  const router = useRouter();
  const resume = useAppSelector(selectResume);
  const isAuthenticationOpen = useAppSelector(selectIsAuthenticationOpen);
  const dispatch = useDispatch();
  // console.log("resume in select experience page:", resume);
  
  useEffect(() => {
    
    if (!resume?.profile?.name) {
      router.push('/upload-resume');
    }
  }, [router, resume]);
  
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const accessToken = localStorage.getItem('access-token');
    
    if (isExperienceSelected && experienceLevel && accessToken) {
      setExperienceCache({experience: experienceLevel});
      router.push(`/score-check?source=experience&level=${experienceLevel}`);
    }
    else if (isExperienceSelected && experienceLevel && !accessToken) {
      dispatch(setIsAuthenticationOpen(true));
    }
  }, [isExperienceSelected, experienceLevel, router]);
  
  return (
    <main className="relative h-screen w-full overflow-hidden bg-[#F1F1F1]">
      <Navbar />
      <div className="flex h-full flex-col items-center justify-center pb-20">
        <ExperienceSelector
          handleAnalyseResume={() => {
            if (experienceLevel) {
              setIsExperienceSelected(true);
            }
          }}
          setIsExperienceSelected={setIsExperienceSelected}
          setExperienceLevel={setExperienceLevel}
        />
      </div>
      {isAuthenticationOpen && <AuthenticationOptions redirectTo="/select-experience"/>}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </main>
  );
};

export default SelectExperiencePage;